<script>
  export let isDesktop
  export let utsnitt
</script>

{#if utsnitt === 'global' && !isDesktop}
  <g transform={`translate(835, 230) scale(2.02)`}>
    <slot />
  </g>
{:else}
  <slot />
{/if}
